export default "__VITE_ASSET__a44f2523__"